// extracted by css-extract-rspack-plugin
export default {"text03":"WorkHours_text03__PEHuW","maxHoursError":"WorkHours_maxHoursError__gK6Jh","stats":"WorkHours_stats__73se-","stat":"WorkHours_stat__wX7YP"};